import Ajax from './Ajax.js'

const Upload = {
  postUploads: (params) => {
    return Ajax.post('/upload', params)
  },
}

export default Upload
